import Select from 'react-select';
import { useLiveQuery } from "dexie-react-hooks";
import { db, withExtras, withParents, withFormulas } from "../../Utils/Functions/Dexie-Setup";
import { tableConfigs } from "../../Utils/Functions/Table_Configs";
import { useMemo, useCallback } from "react"


//defaultValues, canCreate, 
const MultipleChoiceInput = ({tableName, primaryKey, fieldName, label, disabled, ...rest}) => {
    const record = useLiveQuery(() => db[tableName].get(primaryKey), [primaryKey, tableName]);
    const field = useMemo(() => tableConfigs[tableName].fields.find(field => field.label === fieldName), [tableName, fieldName]);
    const options = useMemo(() => field.options.map(option => ({label: option, value: option})), [field]);

    // const keyField = useMemo(() => tableConfigs[tableName].fields.find(field => field.type === "key").label, [tableName]);

    // const createOptions = useCallback((records) => {
    //     console.log({records})
    //     return records?.map(record => ({
    //         label: displayFields.map((curr) => record[curr]).join(" | "),
    //         value: record[keyField],
    //     }))
    // }, [displayFields, keyField])

    // const options = useLiveQuery(() => db[tableName].filter(filter).toArray(withExtras(tableName, [withParents, withFormulas, ()=>createOptions])), [tableName, filter])
    
    const onChange = useCallback((newValue) => db[tableName].update(primaryKey, {[fieldName]: newValue?.value ?? "", locallyUpdatedAt: Date.now()}))

    return (
        // <div className="mb-5 min-w-80 flex flex-col w-80">
        <>
            <label htmlFor={`${tableName}-${label}`} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
                <Select 
                id={`${tableName}-${label}`}
                isClearable
                onChange={onChange}
                options={options}
                value={options?.find(({value}) => value === record?.[fieldName]) ?? null}
                isDisabled={!!disabled}
                {...rest}
                />
        </>
    )
}

export default MultipleChoiceInput